import { makeStyles } from '@fluentui/react-components';
import { isMobile } from 'react-device-detect';

import { customTokens } from 'src/utils/theme';

export const useRewardProgramCardStyles = makeStyles({
  header: {
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    justifyContent: 'space-between',
    alignItems: isMobile ? 'flex-start' : 'center',
    flexWrap: 'wrap',
    gap: customTokens.spacingVerticalM,
  },
  programName: {
    fontWeight: customTokens.fontWeightSemibold,
    fontSize: customTokens.fontSizeBase400,
    lineHeight: customTokens.lineHeightBase400,
    marginBottom: isMobile ? customTokens.spacingVerticalS : undefined,
    flex: 'unset',
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: customTokens.spacingVerticalL,
  },
});
